module.exports = __webpack_public_path__ + "static/media/ZA.61c0b25f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/ZA.svg
// module id = 395
// module chunks = 0